'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectHitsPerPage = require('../connectors/connectHitsPerPage.js');

var _connectHitsPerPage2 = _interopRequireDefault(_connectHitsPerPage);

var _HitsPerPage = require('../components/HitsPerPage.js');

var _HitsPerPage2 = _interopRequireDefault(_HitsPerPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The HitsPerPage widget displays a dropdown menu of the chosen number of items to be displayed.
 * With it a user can choose to display more or fewer results from Algolia.
 *
 * List of hits per page options.
 * Passing a list of numbers `[n]` is a shorthand for `[{value: n, label: n}]`.
 * Beware: the `label` of `HitsPerPage` items must be either a string or a number.
 * @name HitsPerPage
 * @kind widget
 * @propType {number} defaultRefinement - The number of items selected by default
 * @propType {{value, label}[]|number[]} items - List of hits per page options. Passing a list of numbers [n] is a shorthand for [{value: n, label: n}].
 * @propType {function} [transformItems] - If provided, this function can be used to modify the `items` provided prop of the wrapped component (ex: for filtering or sorting items). this function takes the `items` prop as a parameter and expects it back in return.
 * @themeKey ais-HitsPerPage__root - the root of the component.
 * @example
 * import React from 'react';

 * import {
 *   InstantSearch,
 *   HitsPerPage,
 * } from 'react-instantsearch/dom';
 *
 * export default function App() {
 *   return (
 *     <InstantSearch
 *       className="container-fluid"
 *       appId="latency"
 *       apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *       indexName="ikea"
 *     >
 *       <HitsPerPage defaultRefinement={20}/>
 *     </InstantSearch>
 *   );
 * }
 */
var _default = (0, _connectHitsPerPage2.default)(_HitsPerPage2.default);

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/widgets/HitsPerPage.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/widgets/HitsPerPage.js
// module id = 1188
// module chunks = 0